import type { NewBillingCycle } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import React, { useState } from 'react';
import { PlusAddButton } from '../../../components/design/buttons/PlusAddButton';
import { useCreateBillingCycle } from '../../../hooks/requests/use-create-billing-cycle';
import { AddEditBillingCycleDialog } from './AddEditBillingCycleDialog';

export const BillingCycleOverviewHeader = () => {
  const [addBillingCycleDialogOpen, setAddBillingCycleDialogOpen] = useState<boolean>(false);
  const { mutate: createBillingCycleMutation } = useCreateBillingCycle();

  const createBillingCycle = (newBillingCycle: NewBillingCycle, onSuccess?: () => void) => {
    if (isNotNullOrUndefined(newBillingCycle)) {      
      createBillingCycleMutation(
        {
          newBillingCycle,
        },
        {
          onSuccess,
        },
      );
    }
  };

  return (
    <>
      <div className="border-b-line flex items-center justify-between border-b bg-white p-6">
        <div className="text-3xl font-medium">Billing Cycles</div>
        <PlusAddButton
          url=""
          onClick={() => setAddBillingCycleDialogOpen(true)}
        />
      </div>
      <AddEditBillingCycleDialog
        open={addBillingCycleDialogOpen}
        onClose={() => setAddBillingCycleDialogOpen(false)}
        onSubmit={createBillingCycle}
      />
    </>
  );
};